import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";

const PREVIEWS = {
  Today: {
    title: "Your personal daily reading",
    desc: "Every morning Astra writes a reading for your exact Sun, Moon and Rising, with love, money and the week ahead.",
    body: (
      <div className="space-y-2">
        <p className="text-xs text-[#A7B0C0]">Mood · <span className="text-starlight">Bold & curious</span> · Lucky colour · <span className="text-starlight">Crimson</span></p>
        <p className="text-base text-[#D6D0C5] leading-relaxed">“Today your Leo rising strides forward with quiet confidence while your Gemini Sun keeps your mind flickering between ideas…”</p>
      </div>
    ),
  },
  Chart: {
    title: "Your birth chart",
    desc: "See your Sun, Moon and Rising signs, and what each one says about you.",
    body: (
      <div className="grid grid-cols-3 gap-2 text-center">
        {[["SUN", "♊", "Gemini"], ["MOON", "♈", "Aries"], ["RISING", "♌", "Leo"]].map(([l, g, s]) => (
          <div key={l} className="border border-[#D4AF37]/30 rounded-xl py-3">
            <p className="gold-text text-2xl">{g}</p><p className="text-sm">{s}</p><p className="text-[10px] tracking-widest text-[#A7B0C0]">{l}</p>
          </div>
        ))}
      </div>
    ),
  },
  Archive: {
    title: "Your archive",
    desc: "Save the readings and answers that speak to you, and come back to them any time.",
    body: (
      <ul className="space-y-2">
        {["Daily Reading · 23 Oct", "Synastry · Alex & Jordan · 82", "Ask Astra · “What should I focus on this month?”"].map((t) => (
          <li key={t} className="border border-[#D4AF37]/20 rounded-xl px-3 py-2.5 text-sm text-[#E8DCC4]">{t}</li>
        ))}
      </ul>
    ),
  },
  Sanctuary: {
    title: "Your sanctuary",
    desc: "Choose your reminder time, track your reading streak and earn badges along the way.",
    body: <p className="text-base text-[#D6D0C5]">7-day streak · next badge at 30 days · reminders at 8:00</p>,
  },
};

export default function PreviewSheet({ label, onClose }) {
  const p = PREVIEWS[label];
  return (
    <Sheet open={!!p} onOpenChange={(o) => !o && onClose()}>
      <SheetContent side="bottom" data-testid="preview-sheet" className="max-w-md mx-auto bg-[#0B0F19] border-t border-[#D4AF37]/30 text-starlight rounded-t-3xl">
        {p && (
          <>
            <SheetHeader className="text-left">
              <p className="text-[11px] uppercase tracking-[0.3em] gold-text flex items-center gap-1.5"><Sparkles size={12} /> A peek inside</p>
              <SheetTitle data-testid="preview-sheet-title" className="text-2xl font-light text-starlight">{p.title}</SheetTitle>
              <SheetDescription className="text-[#A7B0C0]">{p.desc}</SheetDescription>
            </SheetHeader>
            <div className="mt-4 rounded-2xl bg-[#0F1523] border border-[#D4AF37]/15 p-4" data-testid="preview-sheet-sample">{p.body}</div>
            <p className="text-xs text-[#6c7686] mt-2">Sample shown. Yours is written from your own birth chart.</p>
            <Link to="/join" data-testid="btn-preview-sheet-start"
              className="block text-center w-full mt-5 border border-[#D4AF37]/60 hover:bg-[#D4AF37]/10 gold-text text-lg py-3 rounded-full transition-colors">
              See mine, it's free
            </Link>
            <div className="flex justify-between mt-3 mb-2 text-sm">
              <button onClick={onClose} data-testid="btn-preview-sheet-keep" className="text-[#A7B0C0] hover:text-starlight py-2">Keep exploring</button>
              <Link to="/join?mode=login" data-testid="btn-preview-sheet-signin" className="gold-text py-2">Sign in</Link>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
